import { useLayoutEffect } from 'react';
import { gsap } from '../animation';

// Builds a scene's GSAP timelines scoped to its stage and reverts all of them on
// unmount. With reduced motion `build` receives `still: true` and should only
// set a composed frame.
export default function useSceneAnimation(stageRef, build) {
  useLayoutEffect(() => {
    const stage = stageRef.current;
    if (!stage) return undefined;
    const mm = gsap.matchMedia(stage);
    mm.add({ motion: '(prefers-reduced-motion: no-preference)', still: '(prefers-reduced-motion: reduce)' },
      ({ conditions }) => build(gsap.utils.selector(stage), conditions));
    return () => mm.revert();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
}
